import { getClient } from './client';
import { API_URL } from './apiDictionary';
import { PaginatedResponse } from '@dynamika-shared/types/general';
import { prepareUrl } from '@utils/routerHelpers';

export type OverviewUpload = {
  isTaskPageItemDto: {
    id: string;
    assigneeId: string;
    assigneeName: string;
    completionDate: string;
    unread: boolean;
    patientCode: string;
    visitDefinitionId: string;
    visitId: string;
    visitName: string;
    visitType: string;
    visitEarlyTermination: boolean;
    latestUpload: string;
    siteId: string;
    siteCode: string;
    status: string;
  };
  count: number;
};

export type LabeledSeries = {
  seriesInstanceUid: string;
  labelName: string;
  labelId: string;
};

export type VisitContext = {
  visitId: string;
  visitName: string;
  studyInstanceUid: string;
  labeledSeries: LabeledSeries[];
};

export type ISTasksContextResponse = {
  patientCode: string;
  visitContext: VisitContext[];
};

export const fetchISTasks = (
  clinicalTrialId: string,
  filters: Partial<{ patientCode: string; sort: string }>,
  page?: number,
  size?: number
) => {
  const api = getClient(API_URL.viewerIsTasks);

  return api.get<PaginatedResponse<OverviewUpload>>(API_URL.viewerIsTasks, {
    headers: {
      'x-dynamika-clinical-trial-id': clinicalTrialId,
    },
    params: {
      page: page ? page - 1 : 0,
      size: size ?? 10,
      ...filters,
    },
  });
};

export const fetchISTasksContext = (clinicalTrialId: string, taskId: string) => {
  const api = getClient(API_URL.viewerIsTasksContext);

  return api.get<ISTasksContextResponse>(
    prepareUrl(API_URL.viewerIsTasksContext, [taskId]),
    {
      headers: {
        'x-dynamika-clinical-trial-id': clinicalTrialId,
      },
    }
  );
};
